import React from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Dashboard from './pages/Dashboard';
import UserManagement from './pages/UserManagement';
import HouseManagement from './pages/HouseManagement';
import ResidentManagement from './pages/ResidentManagement';
import ConsumptionManagement from './pages/ConsumptionManagement';
import BillingManagement from './pages/BillingManagement';
import SubscriptionManagement from './pages/SubscriptionManagement';
import NotificationManagement from './pages/NotificationManagement';
import LogsManagement from './pages/LogsManagement';
import SettingsManagement from './pages/SettingsManagement';
import ProfileManagement from './pages/ProfileManagement';
import Login from './pages/Login';
import { AuthProvider, useAuth } from './context/AuthContext';
import { MenuProvider } from './context/MenuContext';
import { LoadingSpinner } from './components/ui/LoadingSpinner';
import { ErrorBoundary } from './components/ui/ErrorBoundary';
import './styles/AdminApp.css';
import './styles/AdminTheme.css';

const LoadingScreen: React.FC = () => {
  return <LoadingSpinner size="lg" text="Chargement..." fullScreen />;
};

const AdminLayout: React.FC = () => {
  return (
    <MenuProvider>
      <div className="flex min-h-screen bg-[#FAFBFC]">
        <Sidebar />
        <div className="flex-1 flex flex-col min-h-screen lg:ml-64">
          <Header />
          <main className="flex-1 overflow-y-auto bg-[#FAFBFC]">
            <Outlet />
          </main>
        </div>
      </div>
    </MenuProvider>
  );
};

const AdminRoutes: React.FC = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route index element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="users" element={<UserManagement />} />
        <Route path="houses" element={<HouseManagement />} />
        <Route path="residents" element={<ResidentManagement />} />
        <Route path="consumptions" element={<ConsumptionManagement />} />
        <Route path="billing" element={<BillingManagement />} />
        <Route path="subscriptions" element={<SubscriptionManagement />} />
        <Route path="notifications" element={<NotificationManagement />} />
        <Route path="logs" element={<LogsManagement />} />
        <Route path="settings" element={<SettingsManagement />} />
        <Route path="profile" element={<ProfileManagement />} />
        <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
      </Route>
    </Routes>
  );
};

const AdminApp: React.FC = () => {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <AdminRoutes />
      </AuthProvider>
    </ErrorBoundary>
  );
};

export default AdminApp;
